import { BaseFieldClass } from './baseField.class'

import { IButtonField } from '@/types/serverField.type'

export class ButtonFieldClass extends BaseFieldClass {
  declare fieldValue: null
  declare initialValue: null

  constructor (field: IButtonField) {
    super(field)
    this.initialValue = null
    this.fieldValue = null
  }

  prepareValue (_value: unknown): null {
    return null
  }

  getValue (): Record<string, null> {
    return {
      [this.name]: null
    }
  }

  appendToFormData (_formData: FormData): void {}

  getFilterValue (): null {
    return null
  }
}
